let constantKeyValList = {
  // 功能列表
  actionList: [
    {
      key: '查看',
      val: 'look'
    },
    {
      key: '保存',
      val: 'save'
    },
    {
      key: '删除',
      val: 'delete'
    },
    {
      key: '提交',
      val: 'push'
    },
    {
      key: '审核',
      val: 'audit'
    },
    {
      key: '导入',
      val: 'import'
    },
    {
      key: '导出',
      val: 'export'
    },
    {
      key: '设为负责人',
      val: 'leader'
    },
    {
      key: '转移部门',
      val: 'move-folder'
    },
    {
      key: '转移数据',
      val: 'move-data'
    },
    {
      key: '同步',
      val: 'sync'
    }
  ],
  // 核算单-开单公司
  companyList: [
    {
      key: '佛山市极速旺金属科技有限公司',
      val: '佛山市极速旺金属科技有限公司'
    },
    {
      key: '东莞市亿宏金属材料有限公司',
      val: '东莞市亿宏金属材料有限公司'
    }
  ],
  // 客户等级列表
  customerLevelList: [
    {
      key: '=0',
      val: '0'
    },
    {
      key: '>0，且<1万',
      val: '1'
    },
    {
      key: '≥1万，且<2万',
      val: '2'
    },
    {
      key: '≥2万，且<3万',
      val: '3'
    },
    {
      key: '≥3万，且<4万',
      val: '4'
    },
    {
      key: '≥4万，且<5万',
      val: '5'
    },
    {
      key: '≥5万，且<6万',
      val: '6'
    },
    {
      key: '≥6万，且<7万',
      val: '7'
    },
    {
      key: '≥7万，且<8万',
      val: '8'
    },
    {
      key: '≥8万，且<9万',
      val: '9'
    },
    {
      key: '≥9万，且<10万',
      val: '10'
    },
    {
      key: '≥10万，且<50万',
      val: '11'
    },
    {
      key: '≥50万，且<100万',
      val: '12'
    },
    {
      key: '≥100万',
      val: '13'
    }
  ],
  // 跟进等级列表
  genJinLevelList: [
    {
      key: '=0天',
      val: '0'
    },
    {
      key: '>0天，且<7天',
      val: '1'
    },
    {
      key: '≥7天，且<15天',
      val: '2'
    },
    {
      key: '≥15天，且<30天',
      val: '3'
    },
    {
      key: '≥30天，且<60天',
      val: '4'
    },
    {
      key: '≥60天，且<90天',
      val: '5'
    },
    {
      key: '≥90天，且<180天',
      val: '6'
    },
    {
      key: '≥180天，且<1年',
      val: '7'
    },
    {
      key: '≥1年，且<2年',
      val: '8'
    },
    {
      key: '≥2年',
      val: '9'
    }
  ],
  // 字段类型列表
  ziDuanTypeList: [
    {
      key: 1,
      val: 'text',
      default: ''
    },
    {
      key: 2,
      val: 'number',
      default: ''
    },
    {
      key: 3,
      val: 'textarea',
      default: ''
    },
    {
      key: 4,
      val: 'text', // spec 规格
      default: ''
    },
    {
      key: 5,
      val: 'date',
      default: ''
    },
    {
      key: 6,
      val: 'datetime',
      default: ''
    },
    {
      key: 7,
      val: 'daterange',
      default: []
    },
    {
      key: 8,
      val: 'select',
      default: ''
    },
    {
      key: 9,
      val: 'upload_file',
      default: []
    },
    {
      key: 10,
      val: 'upload_image',
      default: []
    },
    {
      key: 11,
      val: 'text', // gong_shi 公式
      default: ''
    }
  ],
  ziDuanSymbolList: [
    {
      key: ',',
      val: ','
    },
    {
      key: '*',
      val: '*'
    },
    {
      key: '#',
      val: '#'
    },
    {
      key: '/',
      val: '/'
    }
  ],
  pmcTypeList: [
    {
      key: '制造明细',
      val: '制造明细'
    },
    {
      key: '销售单号',
      val: '销售单号'
    },
    {
      key: '商品名称',
      val: '商品名称'
    },
    {
      key: '业务员',
      val: '业务员'
    },
    {
      key: '客户',
      val: '客户'
    },
    {
      key: '开单公司',
      val: '开单公司'
    }
  ],
  filterResultList: [
    // 制造明细-商品信息
    {
      type: '订单',
      field: '',
      key: '商品信息',
      val: '商品信息',
      count: '订单数量'
    },
    // 制造明细-原材料信息
    {
      type: '原料',
      field: '',
      key: '原材料信息',
      val: '原材料信息',
      count: '含有原材料的订单数量'
    },
    // 制造明细-加工工艺
    {
      type: '加工',
      field: 'process_name',
      key: '加工工艺名称',
      val: '加工工艺名称',
      count: '含有当前加工工艺的订单数量'
    },
    // 销售单号
    {
      type: '订单',
      field: 'bill_code',
      key: '销售单号',
      val: '销售单号',
      count: ''
    },
    // 商品名称
    {
      type: '订单',
      field: 'name',
      key: '商品名称',
      val: '商品名称',
      count: ''
    },
    // 业务员
    {
      type: '订单',
      field: 'saler_id',
      key: '业务员',
      val: '业务员id',
      count: ''
    },
    // 客户
    {
      type: '订单',
      field: 'company_id',
      key: '客户',
      val: '客户id',
      count: ''
    },
    // 开单公司
    {
      type: '订单',
      field: 'saler_company_name',
      key: '开单公司名称',
      val: '开单公司名称',
      count: ''
    }
  ]
}

export default constantKeyValList
